import { useI18n } from 'vue-i18n'
import type { IBaseEntity, IMappedForSchemaEntity } from '~/components/entity/base-entity'
import type { IVacancy } from '~/components/entity/vacancy/types'

export function mapItemToSchemaData(entity?: IBaseEntity | null): IMappedForSchemaEntity {
  const { t } = useI18n()
  const baseData = {
    title: entity?.title || '',
    logo: entity?.logo || entity?.organization?.logo,
    url: entity?.url || '',
    description: entity?.description || '',
    call_center_phone: entity?.organization?.call_center_phone || '',
    organization: {
      official_title: entity?.organization?.official_title || '',
      url: entity?.organization?.url || '',
      status: entity?.organization?.status,
      status_comments: entity?.organization?.status_comments
    },
    is_islamic: entity?.is_islamic || false,
    views_count: entity?.views_count || 0,
    updated_at: entity?.updated_at || '',
    status: entity?.status || '',
    amount_from: entity?.amount_from || '',
    status_comments: entity?.status_comments || t('product.inactive_info')
  }

  // Add vacancy-specific fields if entity is a vacancy
  const vacancy = entity as IVacancy
  if (vacancy?.employment_type || vacancy?.base_salary || vacancy?.salary_currency) {
    return {
      ...baseData,
      employment_type: vacancy.employment_type,
      base_salary: vacancy.base_salary,
      salary_currency: vacancy.salary_currency
    }
  }

  return baseData
}
